import axios from "axios";

export default class BookingAPIService {
    constructor(){
        this.api_url=process.env.REACT_APP_BASE_URL;
        this.api_key=process.env.REACT_APP_API_KEY;
    }

    init = () =>{
        console.debug(this.api_key)
        let headers = {
            Authorization:'allow',
        }
        this.client = axios.create({
            baseURL:this.api_url,
            timeout:31000,
            headers: headers,
        })
        return this.client;
    }
    // Get winery tasting room information
 // dev/wineries/V0ktMDAwMDEK/tasting_rooms

    getTableAvaliablities = (tastingRoomId,date,partySize,areaId) =>{
        return this.init().get(`/dev/tasting_rooms/${tastingRoomId}/availabilities?date=${date}&party_size=${partySize}&area_id=${areaId}`);
    }

    postReservation = (reservationJSON, tastingRoomId)=>{
        return this.init().get(`/dev/tasting_rooms/${tastingRoomId}/reservations`,reservationJSON);
    }

    getTastingRooms = (tastingRoomId) =>{
        return this.init().get(`/dev/tasting_rooms/${tastingRoomId}/areas`);
    }

};


